import ImagesJSON from '../../assets/images.json'

export const Images = ImagesJSON
